<template>
    <div>
        <div class="app-title" v-if="!isCleanMode">
            <h2 v-if="appTitle">{{ appTitle }}</h2>
            <em-view-title v-else key="viewTitle" :crudState="$_emCommonListMixin_pathType"
                           @gotMenuName="$emit('gotMenuName', $event)"></em-view-title>
        </div>
        <app-content :flex-column="flexColumn" :card-content="cardContent" :class="contentClass">
            <slot></slot>
        </app-content>
        <slot name="outer"></slot>
    </div>
</template>

<script>
import AppContent from "@/components/echarts-part/stuff/AppContent";
import emCommonListMixin from "@/mixin/em/common/list";
import {isNeedCleanApp} from "@/utils/mobileUtil";

export default {
    name: "CommonPage",
    components: {AppContent},
    mixins: [emCommonListMixin],
    props: {
        flexColumn: {
            type: Boolean,
            default: false
        },
        appTitle: {
            type: String,
            default: undefined
        },
        cardContent: {
            type: Boolean,
            default: false
        },
        contentClass: String,
    },
    computed: {
        isCleanMode() {
            return isNeedCleanApp(window.location.pathname);
        },
    },
}
</script>

<style scoped>

</style>
